// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"EditFulfillerModal_modal-wrapper__rJ8x2"};